var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{class:{ 'hidden': _vm.loading}},[_c('localization')],1),(_vm.loading || _vm.adminLoading)?_c('div',{staticClass:"overlay"},[_c('div',{staticClass:"spinner-wrapper"},[_c('b-spinner',{staticStyle:{"width":"3rem","height":"3rem"},attrs:{"variant":"info"}})],1)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }